var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1116_1588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7659 0H3.23429C1.44821 0 0.000244141 1.44791 0.000244141 3.23405V20.7658C0.000244141 22.552 1.44815 23.9999 3.23429 23.9999H11.8808L11.8956 15.4236H9.66746C9.3779 15.4236 9.14286 15.1895 9.14178 14.8999L9.13106 12.1354C9.12998 11.8443 9.36571 11.6077 9.65683 11.6077H11.8809V8.93652C11.8809 5.8366 13.7741 4.14868 16.5394 4.14868H18.8086C19.0989 4.14868 19.3343 4.38408 19.3343 4.67444V7.00548C19.3343 7.29572 19.0991 7.53104 18.8089 7.5312L17.4163 7.53188C15.9125 7.53188 15.6213 8.24648 15.6213 9.29524V11.6078H18.9257C19.2406 11.6078 19.4849 11.8827 19.4478 12.1954L19.1201 14.9599C19.0888 15.2244 18.8645 15.4238 18.5981 15.4238H15.636L15.6213 24H20.7661C22.5521 24 24.0001 22.5521 24.0001 20.766V3.23405C24 1.44791 22.5521 0 20.7659 0Z",
    fill: "#3D1CAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1116_1588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.cfbe7c04c60ad238c0e5e1369d68a588.svg";
export { ForwardRef as ReactComponent };